import { dashboardAPI } from "@/services";

export default {
  initialLogin(context) {
    var loginAPI = dashboardAPI.getLoginAPI();
    var loginContext = {
      user: context.rootState.app.userInfo.username,
      accessToken:
        context.rootState.app.userInfo.signInUserSession.accessToken.jwtToken,
    };

    localStorage.setItem(
      "accessToken",
      context.rootState.app.userInfo.signInUserSession.accessToken.jwtToken
    );
    localStorage.setItem("accessUser", context.rootState.app.userInfo.username);

    return loginAPI.getAllData(loginContext).then(async (response) => {
      context.commit("IsAdmin", response.IsAdmin);
      // Store the user's DynamoDB event permissions so getEventMetadata can
      // attach Permission (Read/Write/None) onto the selected event
      context.commit("setUserEventPermissions", response.Events || []);

      context.commit("setFilterYear", parseInt(response.RecentlyViewed.Year));

      // Await event metadata so callers (App.vue) only refresh once the event is set
      const fetchedRecentEvent = await context.dispatch(
        "admin/getEventMetadata",
        response.RecentlyViewed.EventId,
        { root: true }
      );
      context.commit("setGlobalEventFilter", fetchedRecentEvent);
      const yearNum = parseInt(
        fetchedRecentEvent.Year ?? response.RecentlyViewed.Year,
        10
      );
      context.commit("setGlobalYearFilter", { Year: yearNum });
      context.commit("setAllVouchers", fetchedRecentEvent.Vouchers);
      context.dispatch("extractAllStalls", fetchedRecentEvent.Stallholders);

      if (fetchedRecentEvent.Stallholders && fetchedRecentEvent.Stallholders[0]) {
        localStorage.setItem(
          "setSelectedStallholderId",
          fetchedRecentEvent.Stallholders[0].StallholderId
        );
      }

      return response;
    });
  },

  extractAllStalls(context, stallHolders) {
    console.log("extractAllStalls", stallHolders);

    var listOfStalls = stallHolders.map((stallHolder) => stallHolder.Stalls);
    listOfStalls = listOfStalls.flat();

    var listOfTerminalUsers = stallHolders.map(
      (stallHolder) => stallHolder.TerminalUsers
    );
    listOfTerminalUsers = listOfTerminalUsers.flat();

    context.commit("setAllStalls", listOfStalls);
    context.commit("setAllTerminalUsers", listOfTerminalUsers);

    // context.commit('setFilterStalls', listOfStalls)
    // context.commit('setFilterTerminalUser', listOfTerminalUsers)

    // context.dispatch('extractAllTerminals', listOfStalls)
  },
  // extractAllTerminals(context, stalls) {
  //   var listOfTerminals = stalls.map(stall => stall.Terminals )
  //   listOfTerminals = listOfTerminals.flat()

  //   listOfTerminals = listOfTerminals.filter(element => {
  //     return element !== undefined;
  //   });

  //   // context.commit('setAllTerminals', listOfTerminals)
  //   // context.commit('setFilterTerminals', listOfTerminals)
  // }
};
